// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interview-mode-wrapper {
    background-color: rgba(15, 1, 37, 1);
    color: #fff;
    height: 100vh;
    padding: 40px 50px;
}

.interview-mode-wrapper .header {
    margin-bottom: 30px;
    display: unset;
    border-bottom: none;
    background-color: transparent;
}

.interview-mode-wrapper .header-wrap .logo {
    max-width: 100px;
    display: block;
    margin-bottom: 10px;
}

.interview-mode-wrapper .interview-details {
    margin-top: 10px;
}

.interview-mode-wrapper .header-wrap .title {
    font-size: 18px;
    font-weight: 400;
    line-height: 34px;
    text-align: left;
    display: block;
    font-family: "Inter", sans-serif;
}

.interview-mode-wrap {
    padding-top: 10px;
}

.interview-mode-wrapper .interview-details .caller-details {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.20);
    font-family: "Inter", sans-serif;
    display: flex;
}

.interview-mode-wrapper .caller-details span {
    font-weight: 600;
}

.interview-mode-wrapper .interview-details .caller-details .dot {
    display: block;
}

.interview-mode-top-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.interview-mode-top-content .status {
    color: #38BBF4;
    font-size: 24px;
    font-weight: 600;
    line-height: 75px;
}

.interview-mode-top-content .start-interview-button {
    background-color: #F84242;
    color: white;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    /* padding: 18px 52px; */
    width: 310px;
    height: 50px;
    border: none;
    cursor: pointer;
    font-family: "Inter", sans-serif;

}

.interview-mode-top-content .start-interview-button img {
    width: 20px;
    height: 20px;
}

.interview-mode-bottom-content {
    display: flex;
    margin-top: 10px;
    justify-content: center;
}

.interview-mode-bottom-content .left-img-wrap {
    position: relative;
}

.interview-mode-bottom-content .left-img-wrap img {
    width: 100%;
}

.interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {
    position: absolute;
    top: 3%;
    right: 3%;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.81);
    height: 88px;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {
    font-weight: 700;
    line-height: 50px;
    font-size: 18px;
    color: #000000;
    font-family: "Inter", sans-serif;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title span {
    font-weight: 500;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {
    display: flex;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {
    width: 40px;
}

.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button {
    background-color: transparent;
    border: none;
}


.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {
    padding-left: 20px;
}

.interview-mode-bottom-content .right-img-wrap {
    position: relative;
}

.interview-mode-bottom-content .right-img-wrap img {
    width: 100%;
}

.interview-mode-bottom-content .right-img-wrap .bottom-title span {
    font-weight: 500;
}

.interview-mode-bottom-content .right-img-wrap .bottom-title {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.81);
    height: 88px;
    width: 100%;
    bottom: 0;
    font-weight: 700;
    line-height: 50px;
    font-size: 18px;
    color: #000000;
    padding-left: 20px;
    font-family: "Inter", sans-serif;
}

.interview-mode-bottom-content .top-title-mob {
    display: none;
}

.interview-mode-bottom-content .top-title-mob span {
    display: none;
}

.interview-mode-bottom-wrap {
    display: none;
}

@media (max-width: 1650px) {
    .interview-mode-bottom-content .left-img-wrap .caller-img {
        width: 400px;
    }

    .interview-mode-bottom-content .right-img-wrap .caller-img {
        width: 400px;
    }

    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {
        font-size: 16px;
    }

    .interview-mode-bottom-content .right-img-wrap .bottom-title {
        display: flex;
        align-items: center;
        font-size: 16px;
    }
}

@media (max-width: 768px) {
    .interview-mode-wrapper {
        padding: 32px 20px;
        height: 100%;
    }

    .interview-mode-wrapper .header-wrap .logo {
        margin: 0 auto;
    }

    .interview-mode-top-content {
        display: none;
    }

    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {
        top: 4%;
    }

    .interview-mode-wrap {
        padding-top: 10px;
    }

    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon img {
        width: 40px;
        height: 40px;
    }

    .interview-mode-bottom-content {
        flex-direction: column;
        margin-top: 15px;
    }

    .interview-mode-wrapper .header-wrap .title {
        display: none;
    }

    .interview-mode-wrapper .interview-details .caller-details {
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        font-family: "Inter", sans-serif;
        flex-direction: column;
        border-bottom: none;
    }

    .interview-mode-wrapper .interview-details .caller-details .dot {
        display: none;
    }

    .interview-mode-bottom-content .left-img-wrap .top-title-mob {
        display: block;
        background-color: #ffffff;
        color: #38BBF4;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 10px;
        padding: 6px 10px;
        position: absolute;
        left: 2%;
        top: 5%;
        font-family: "Inter", sans-serif;
    }

    .interview-mode-bottom-content .top-title-mob span {
        display: none;
    }

    .interview-mode-bottom-content .left-img-wrap .top-title-mob img {
        width: 16px;
        height: 16px;
    }

    .interview-mode-bottom-content .left-img-wrap .caller-img {
        border-radius: 10px;
        height: 100%;
        width: 100%;
    }

    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap {
        height: 42px;
        border-radius: 0px 0px 10px 10px;
        justify-content: flex-start;
        padding-left: 10px;
    }

    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;

    }

    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title span {
        font-weight: 500;
    }

    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {
        display: none;
    }

    .interview-mode-bottom-content .right-img-wrap {
        margin-top: 20px;
    }

    .interview-mode-bottom-content .right-img-wrap img {
        border-radius: 10px;
    }

    .interview-mode-bottom-content .right-img-wrap .caller-img {
        width: 100%;
        height: 100%;
    }

    .interview-mode-bottom-content .right-img-wrap .bottom-title {
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
        height: 42px;
        border-radius: 0px 0px 10px 10px;
        padding-left: 10px;
        display: flex;
        align-items: center;
        font-family: "Inter", sans-serif;
    }

    .interview-mode-bottom-content .right-img-wrap .bottom-title span {
        font-weight: 500;
    }

    .interview-mode-bottom-wrap {
        display: flex;
        justify-content: center;
        padding-top: 22px;
    }

    .interview-mode-bottom-wrap .mid-icn {
        padding: 0px 20px;
    }

}

@media (max-width: 400px) {
    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {
        top: 5%;
    }

    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon img {
        width: 30px;
        height: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/InterviewMode/InterviewMode.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kDAAkD;IAClD,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gCAAgC;;AAEpC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,gCAAgC;QAChC,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,gCAAgC;IACpC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,gCAAgC;QAChC,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;;IAEpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,gCAAgC;QAChC,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA;IACI;QACI,OAAO;IACX;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".interview-mode-wrapper {\n    background-color: rgba(15, 1, 37, 1);\n    color: #fff;\n    height: 100vh;\n    padding: 40px 50px;\n}\n\n.interview-mode-wrapper .header {\n    margin-bottom: 30px;\n    display: unset;\n    border-bottom: none;\n    background-color: transparent;\n}\n\n.interview-mode-wrapper .header-wrap .logo {\n    max-width: 100px;\n    display: block;\n    margin-bottom: 10px;\n}\n\n.interview-mode-wrapper .interview-details {\n    margin-top: 10px;\n}\n\n.interview-mode-wrapper .header-wrap .title {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 34px;\n    text-align: left;\n    display: block;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-mode-wrap {\n    padding-top: 10px;\n}\n\n.interview-mode-wrapper .interview-details .caller-details {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.20);\n    font-family: \"Inter\", sans-serif;\n    display: flex;\n}\n\n.interview-mode-wrapper .caller-details span {\n    font-weight: 600;\n}\n\n.interview-mode-wrapper .interview-details .caller-details .dot {\n    display: block;\n}\n\n.interview-mode-top-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.interview-mode-top-content .status {\n    color: #38BBF4;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 75px;\n}\n\n.interview-mode-top-content .start-interview-button {\n    background-color: #F84242;\n    color: white;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    /* padding: 18px 52px; */\n    width: 310px;\n    height: 50px;\n    border: none;\n    cursor: pointer;\n    font-family: \"Inter\", sans-serif;\n\n}\n\n.interview-mode-top-content .start-interview-button img {\n    width: 20px;\n    height: 20px;\n}\n\n.interview-mode-bottom-content {\n    display: flex;\n    margin-top: 10px;\n    justify-content: center;\n}\n\n.interview-mode-bottom-content .left-img-wrap {\n    position: relative;\n}\n\n.interview-mode-bottom-content .left-img-wrap img {\n    width: 100%;\n}\n\n.interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {\n    position: absolute;\n    top: 3%;\n    right: 3%;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap {\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.81);\n    height: 88px;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 20px;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {\n    font-weight: 700;\n    line-height: 50px;\n    font-size: 18px;\n    color: #000000;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title span {\n    font-weight: 500;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {\n    display: flex;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {\n    width: 40px;\n}\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button {\n    background-color: transparent;\n    border: none;\n}\n\n\n.interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {\n    padding-left: 20px;\n}\n\n.interview-mode-bottom-content .right-img-wrap {\n    position: relative;\n}\n\n.interview-mode-bottom-content .right-img-wrap img {\n    width: 100%;\n}\n\n.interview-mode-bottom-content .right-img-wrap .bottom-title span {\n    font-weight: 500;\n}\n\n.interview-mode-bottom-content .right-img-wrap .bottom-title {\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.81);\n    height: 88px;\n    width: 100%;\n    bottom: 0;\n    font-weight: 700;\n    line-height: 50px;\n    font-size: 18px;\n    color: #000000;\n    padding-left: 20px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-mode-bottom-content .top-title-mob {\n    display: none;\n}\n\n.interview-mode-bottom-content .top-title-mob span {\n    display: none;\n}\n\n.interview-mode-bottom-wrap {\n    display: none;\n}\n\n@media (max-width: 1650px) {\n    .interview-mode-bottom-content .left-img-wrap .caller-img {\n        width: 400px;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap .caller-img {\n        width: 400px;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {\n        font-size: 16px;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap .bottom-title {\n        display: flex;\n        align-items: center;\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .interview-mode-wrapper {\n        padding: 32px 20px;\n        height: 100%;\n    }\n\n    .interview-mode-wrapper .header-wrap .logo {\n        margin: 0 auto;\n    }\n\n    .interview-mode-top-content {\n        display: none;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {\n        top: 4%;\n    }\n\n    .interview-mode-wrap {\n        padding-top: 10px;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon img {\n        width: 40px;\n        height: 40px;\n    }\n\n    .interview-mode-bottom-content {\n        flex-direction: column;\n        margin-top: 15px;\n    }\n\n    .interview-mode-wrapper .header-wrap .title {\n        display: none;\n    }\n\n    .interview-mode-wrapper .interview-details .caller-details {\n        text-align: center;\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 400;\n        font-family: \"Inter\", sans-serif;\n        flex-direction: column;\n        border-bottom: none;\n    }\n\n    .interview-mode-wrapper .interview-details .caller-details .dot {\n        display: none;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-title-mob {\n        display: block;\n        background-color: #ffffff;\n        color: #38BBF4;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 20px;\n        border-radius: 10px;\n        padding: 6px 10px;\n        position: absolute;\n        left: 2%;\n        top: 5%;\n        font-family: \"Inter\", sans-serif;\n    }\n\n    .interview-mode-bottom-content .top-title-mob span {\n        display: none;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-title-mob img {\n        width: 16px;\n        height: 16px;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .caller-img {\n        border-radius: 10px;\n        height: 100%;\n        width: 100%;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap {\n        height: 42px;\n        border-radius: 0px 0px 10px 10px;\n        justify-content: flex-start;\n        padding-left: 10px;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title {\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 700;\n\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .bottom-title span {\n        font-weight: 500;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {\n        display: none;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap {\n        margin-top: 20px;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap img {\n        border-radius: 10px;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap .caller-img {\n        width: 100%;\n        height: 100%;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap .bottom-title {\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 700;\n        height: 42px;\n        border-radius: 0px 0px 10px 10px;\n        padding-left: 10px;\n        display: flex;\n        align-items: center;\n        font-family: \"Inter\", sans-serif;\n    }\n\n    .interview-mode-bottom-content .right-img-wrap .bottom-title span {\n        font-weight: 500;\n    }\n\n    .interview-mode-bottom-wrap {\n        display: flex;\n        justify-content: center;\n        padding-top: 22px;\n    }\n\n    .interview-mode-bottom-wrap .mid-icn {\n        padding: 0px 20px;\n    }\n\n}\n\n@media (max-width: 400px) {\n    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {\n        top: 5%;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon img {\n        width: 30px;\n        height: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
